import { useState } from "react"
import { ErrorInfo } from "./error-info";
import { isAxiosError } from "axios";
import { SolidButton } from "@components/form/button/SolidButton";
import { DialogWithHeader } from "@components/dialog";
import { TableError } from "./table-error";



export interface ButtonErrorProps{
  error: Error
}

export function ButtonError(props: ButtonErrorProps){

  const [isModalOpen, setIsModalOpen] = useState(false);

  if(isAxiosError(props?.error)) return(
    <>
      <SolidButton variant="danger" className="px-3" onClick={()=>setIsModalOpen(!isModalOpen)}>
        Error
      </SolidButton>
      <DialogWithHeader
        isOpen={isModalOpen}
        modalAccess={setIsModalOpen}
        title="Error"
      >
        <TableError error={props.error} />
      </DialogWithHeader>
    </>

  )

  return (
  <SolidButton variant="danger" disabled>
    Error - {props.error.message}
  </SolidButton>
  )
  
}
